import React from 'react';
import { Link } from 'react-router-dom';

const RowlyPrivacy = () => {
  return (
    <div className="min-h-screen bg-cream-100 relative">
      {/* Grain texture overlay */}
      <div className="grain-overlay" aria-hidden="true"></div>

      {/* Header */}
      <header className="pt-16 md:pt-24 pb-12 px-6 md:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="animate-on-load animate-fade-in-up">
            <Link
              to="/"
              className="font-body text-ink-muted hover:text-ink text-sm uppercase tracking-widest mb-6 inline-block transition-colors"
            >
              ← Home
            </Link>
            <p className="font-body text-ink-muted text-sm uppercase tracking-widest mb-4">
              Last updated: February 16, 2026
            </p>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink tracking-tight">
              Privacy Policy
            </h1>
            <p className="font-body text-ink-muted text-lg mt-4">
              Rowly
            </p>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="px-6 md:px-12 pb-24">
        <div className="max-w-3xl mx-auto">
          <div className="editorial-divider mb-12"></div>

          <article className="font-body text-ink-light leading-relaxed text-lg animate-on-load animate-fade-in-up animate-delay-200">
            <h2 className="font-serif text-2xl md:text-3xl text-ink mt-12 mb-6">
              The Short Version
            </h2>
            <p className="mb-6">
              Rowly does not collect, transmit, or share any of your data. Period.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-ink mt-12 mb-6">
              Details
            </h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>
                <strong className="font-medium text-ink">No data collection.</strong> Rowly does not collect personal information, usage analytics, telemetry, crash reports, or any other data.
              </li>
              <li>
                <strong className="font-medium text-ink">No network access.</strong> The app makes zero network requests. Your files and edits never leave your machine.
              </li>
              <li>
                <strong className="font-medium text-ink">No accounts.</strong> There is no sign-up, login, or user account of any kind.
              </li>
              <li>
                <strong className="font-medium text-ink">Local storage only.</strong> Your preferences (such as theme selection and recent file history) are stored locally on your device using standard application storage. This data is never transmitted anywhere.
              </li>
              <li>
                <strong className="font-medium text-ink">No third-party services.</strong> Rowly does not integrate with any third-party analytics, advertising, or tracking services.
              </li>
            </ul>

            <h2 className="font-serif text-2xl md:text-3xl text-ink mt-12 mb-6">
              File Access
            </h2>
            <p className="mb-6">
              Rowly accesses files on your computer only when you explicitly open them (via the file picker, drag-and-drop, or recent files list). Files are read and written locally. No copies are made outside of the locations you choose.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-ink mt-12 mb-6">
              Changes to This Policy
            </h2>
            <p className="mb-6">
              If this policy changes, the updated version will be included with the app. Given that Rowly has no mechanism to collect data, meaningful changes are unlikely.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-ink mt-12 mb-6">
              Contact
            </h2>
            <p className="mb-6">
              If you have questions about this policy, please open an issue on the project's repository.
            </p>
          </article>

          <div className="editorial-divider my-12"></div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-cream-300 bg-cream-200/50">
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-12">
          <p className="font-body text-center text-ink-muted text-sm tracking-wide">
            © {new Date().getFullYear()} Teddy Marchildon
          </p>
        </div>
      </footer>
    </div>
  );
};

export default RowlyPrivacy;
